import { Github, Linkedin, Mail, Calendar, BookOpen, LucideIcon } from 'lucide-react';
import React, { useState } from 'react';

const EMAIL = 'szhou27@stanford.edu';

interface SocialLink {
  name: string;
  icon: LucideIcon;
  url?: string;
}

const LINKS: SocialLink[] = [
  { name: 'GitHub', icon: Github, url: 'https://github.com/syz27' },
  { name: 'LinkedIn', icon: Linkedin, url: 'https://www.linkedin.com/in/sarah-zhou/' },
  { name: 'Email', icon: Mail },
  {
    name: 'Schedule',
    icon: Calendar,
    url: 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2WgxTAMrfyhShk9UOGydXnrj6qx5IOLAQ-yB15uwOKWwiDhcuE5Dv8oeNSu_OMgVUrN8SMr3cL',
  },
  { name: 'Substack', icon: BookOpen, url: 'https://substack.com/@szhou27' },
];

/**
 * Row of social icon buttons, shared by the Hero and Footer.
 * `showTooltips` renders hover labels (used in the Hero).
 */
const SocialLinks: React.FC<{ showTooltips?: boolean; className?: string }> = ({
  showTooltips = false,
  className = '',
}) => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={`flex items-center ${className}`}>
      {LINKS.map((link) => (
        <div key={link.name} className="relative group">
          <a
            href={link.url}
            onClick={link.name === 'Email' ? copyEmail : undefined}
            target={link.url ? '_blank' : undefined}
            rel={link.url ? 'noopener noreferrer' : undefined}
            className="flex items-center justify-center w-11 h-11 rounded-full bg-white/70 text-ink-600 hover:bg-white hover:text-blush-500 transition-all shadow-sm"
            title={link.name}
          >
            <link.icon className="w-5 h-5" />
          </a>
          {showTooltips && (
            <div className="absolute -top-9 left-1/2 -translate-x-1/2 bg-ink-700 text-white px-2 py-1 rounded text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
              {link.name}
            </div>
          )}
          {link.name === 'Email' && copied && (
            <div className="absolute -top-9 left-1/2 -translate-x-1/2 bg-ink-700 text-white px-2 py-1 rounded text-xs whitespace-nowrap z-10">
              Email copied!
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SocialLinks;
